<!--
// app/components/pages/region-home/CurrentPlayoffBracket.vue
-->
<script setup lang="ts">
import { useBracketMetaDetection } from "~/app/composables/bracket/useBracketMetaDetection";
import { useCompetitionStore } from "~/app/stores/competitionStore";
import seasonService from "~/src/season-cluster/domain/services/seasonService";
import MetaBracketPlayoff from "~/app/components/pages/region-tables/MetaBracketPlayoff.vue";
import { useWebContext } from "~/app/composables/webContext";
import { useRegions } from "~/app/composables/regions";

const localePath = useLocalePath();
const { hasBracketMetaConfig } = useBracketMetaDetection();
const competitionStore = useCompetitionStore();
const { findSeasonPlayoffPhase } = seasonService();
const { isQueens } = useWebContext();
const { isMena, isBrazil, isAmericas, regionParam } = useRegions();

const currentSeasonPlayoffPhase = competitionStore.currentSeason
  ? findSeasonPlayoffPhase(competitionStore.currentSeason)
  : undefined;

const showCurrentPlayoffBracket = computed(() => {
  return currentSeasonPlayoffPhase && hasBracketMetaConfig(currentSeasonPlayoffPhase);
});

const setBackgroundImage = computed(() => {
  if (isQueens) {
    return "url('/img/brackets/line-bracket-qc.jpg'),url('/img/brackets/bg-bracket-queens.jpg')";
  } else {
    if (isMena) {
      return "url('/img/brackets/line-bracket-kc-mena.jpg'),url('/img/brackets/bg-bracket-kings.jpg')";
    } else if (isAmericas || isBrazil) {
      return "url('/img/brackets/line-bracket-kc-america.jpg'),url('/img/brackets/bg-bracket-kings.jpg')";
    } else {
      return "url('/img/brackets/line-bracket-kc-europe.jpg'),url('/img/brackets/bg-bracket-kings.jpg')";
    }
  }
});
</script>

<template>
  <section
    v-if="showCurrentPlayoffBracket"
    class="kql-w-container mx-4 xl:px-0 mt-6 rounded-lg"
    :style="{
      backgroundImage: setBackgroundImage,
    }"
  >
    <div class="md:p-4 lg:mt-0">
      <div>
        <div
          class="flex text-gray-400 uppercase text-sm mb-2 justify-between items-end px-4 md:px-0 pt-4 md:pt-0"
        >
          <p>Playoff</p>
        </div>
        <hr class="mx-4 md:mx-0" />

        <div class="mt-4 text-center min-h-[150px] pb-8 md:pb-0">
          <meta-bracket-playoff
            is-home
            :region="regionParam"
            :playoff-phase="currentSeasonPlayoffPhase"
            :season-id="competitionStore.currentSeason?.id"
            :winner-team-id="competitionStore.currentSeason?.winnerTeamId || null"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
section {
  background-size:
    auto 38px,
    cover;
  background-position:
    center bottom -2px,
    center right;
  background-repeat: repeat-x, no-repeat;
}
</style>
